import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("span", {
    class: "gfu-contact-form__back-navigation",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('click')), ["prevent"])),
    "data-qa": "contact-form-btn:GoBack"
  }, [
    _createVNode(_component_base_icon, {
      name: "chevron-left",
      class: "_mr-1"
    }),
    _createTextVNode(_toDisplayString(_ctx.Resources.Common.GoBackButton), 1 /* TEXT */)
  ]))
}